import SecurityPage from '@/pages/security/SecurityPage.vue'
import CAForm from '@/pages/security/CAForm.vue'
import CertificateForm from '@/pages/security/CertificateForm.vue'
import ConfigurationForm from '@/pages/security/ConfigurationForm.vue'
import PrivateKeysForm from '@/pages/security/PrivateKeysForm.vue'
import PKCSForm from '@/pages/security/PKCSForm.vue'

export default [
  {
    path: '/security/:id',
    component: SecurityPage,
    props: true
  },
  {
    path: '/security/ca/:mode/:id',
    component: CAForm,
    props: true
  },
  {
    path: '/security/certificate/:mode/:id',
    component: CertificateForm,
    props: true
  },
  {
    path: '/security/configuration/:mode/:id/:idPod/:type',
    component: ConfigurationForm,
    props: true
  },
  {
    path: '/security/privatekey/:mode/:id',
    component: PrivateKeysForm,
    props: true
  },
  {
    path: '/security/pkcs/:mode/:id',
    component: PKCSForm,
    props: true
  },
]
